import React from 'react';
import { Body, Link, LinkProps, VStack } from '@hover/blueprint';
import ArrowButton, { ArrowButtonProps } from '../ArrowButton';
import { HOVER_DOWNLOAD_APP_LINK } from '../../../constants';

interface IGetStartedProps {
  isLoading: boolean;
  onSubmit: ArrowButtonProps['onClick'];
  contentColor?: string;
  description?: string;
  linkColorScheme?: LinkProps['colorScheme'];
}

const GetStarted: React.FC<IGetStartedProps> = ({
  contentColor,
  linkColorScheme,
  description,
  isLoading,
  onSubmit,
}) => (
  <VStack
    maxW={{ base: '100%', tablet: '252px' }}
    w="100%"
    spacing={300}
    alignItems={{ base: 'center', tablet: 'flex-start' }}
  >
    <ArrowButton isLoading={isLoading} onClick={onSubmit} w="100%">
      GET STARTED
    </ArrowButton>
    <Body
      textAlign={{ base: 'center', tablet: 'left' }}
      size={300}
      color={contentColor}
      maxW="188px"
      alignSelf="center"
    >
      We’ll text you a link to download&nbsp;
      <Link
        colorScheme={linkColorScheme}
        href={HOVER_DOWNLOAD_APP_LINK}
        textDecorationColor="currentColor"
      >
        our app
      </Link>
      &nbsp; Nothing else...promise. {description}
    </Body>
  </VStack>
);

export default GetStarted;
